import React, { Component } from "react";
import Media from "react-media";
import { css, StyleSheet } from "aphrodite/no-important";
import PropTypes from "prop-types";

import utils from "libs/utils";

import Image from "components/Image";
import config from "../../data/config";

import Modal from "../../components/Modal/modal";

import visaW from "../../images/visa_white.svg";
import masterW from "../../images/mastercard_white.svg";

import SignUp from "components/Buttons/SignUp";
import playBtn from "../../images/playButton.png";

const logos = [masterW, visaW];

// TODO: Discuss: Fix usage of `text` vs `title`
// TODO: Move into Components
class HeaderBanner extends Component {
  // TODO: Thabang: Depracate support of Array arguments for content?
  static propTypes = {
    // Strings
    title: PropTypes.string,
    header: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object
    ]),
    paragraph: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object
    ]),
    buttonText: PropTypes.string,
    bgColor: PropTypes.string,
    buttonLink: PropTypes.string,

    // Bools
    mediumBanner: PropTypes.bool,
    bgFill: PropTypes.bool,
    bgCover: PropTypes.bool,
    // Images
    bgImage: PropTypes.string,
    bgMobileImage: PropTypes.string
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      embedUrl: `https://www.youtube.com/embed/${
        this.props.videoID
      }?rel=0&amp;showinfo=0`
    };
  }

  openModal = () => {
    console.log("Opening the video modal");
    this.setState({
      modal: true
    });
  };

  closeModal = () => {
    this.setState({
      modal: false
    });
  };

  renderModal() {
    if (this.state.modal) {
      console.log(`First render with video modal.. - ${this.state.embedUrl}`);
      return (
        <Modal close={this.closeModal}>
          <iframe
            width="100%"
            height="330"
            src={`${this.state.embedUrl}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </Modal>
      );
    }
    return null;
  }

  showLogos(logos) {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 599) {
        return;
      }
    }
    return logos.map((img, i) => {
      return <Image key={i} src={img} className="cardLogo" />;
    });
  }

  mobileImage() {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 599) {
        if (!this.props.bgMobileImage) {
          return "";
        }
        return this.props.bgMobileImage
          ? this.props.bgMobileImage
          : this.props.bgImage;
      } else {
        return this.props.bgImage;
      }
    }

    return this.props.bgImage;
  }

  // TODO: Discuss: Generalise and perform inside `renderProp` func.
  renderParagraph = () => {
    const propType = typeof this.props.paragraph;
    let content = undefined;

    if (propType === "object") {
      content = (
        <div className={css(styles.paragraph)}>{this.props.paragraph}</div>
      );
    } else if (propType === "string" || propType === "array") {
      content = <p className={css(styles.paragraph)}>{this.props.paragraph}</p>;
    }
    return content;
  };

  render() {
    const colSize = this.props.bigBanner ? 7 : this.props.mediumBanner ? 6 : 5;
    const bgOverlayOpacityLeft = 0.7;
    const bgOverlayOpacityRight = 0.1;

    return (
      <section
        style={{
          backgroundColor: this.props.bgColor ? this.props.bgColor : "#BDB5B2",
          color: this.props.textColor ? this.props.textColor : "white",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          ...(this.props.bgFill && config.development
            ? {
                backgroundImage: `url(${this.mobileImage()})`
              }
            : {})
        }}
        {...(this.props.bgFill && !config.development
          ? { "data-src-bck": this.mobileImage() }
          : {})}
      >
        <div className="container">
          <div className={`row ${css(styles.bannerStyle)}`}>
            <div
              className={`col-md-${12 -
                colSize}  center-content  d-flex align-items-center bannerPadding`}
            >
              <div>
                {this.props.logo ? (
                  <img src={this.props.logo} className={css(styles.logo)} />
                ) : (
                  ""
                )}
                {this.props.title ? (
                  <h2 className={css(styles.titleStyle)}>{this.props.title}</h2>
                ) : (
                  ""
                )}
                {this.props.header ? (
                  <h1 className={css(styles.fontStyle)}>{this.props.header}</h1>
                ) : (
                  ""
                )}
                {this.props.text ? (
                  <h2 style={{ fontSize: "36px" }}>{this.props.text}</h2>
                ) : (
                  ""
                )}
                {/*{this.props.paragraph ? (*/}
                {/*<p className={css(styles.paragraph)}>*/}
                {/*{this.props.paragraph}*/}
                {/*</p>*/}
                {/*) : (*/}
                {/*""*/}
                {/*)}*/}
                {this.renderParagraph()}
                {this.props.videoID ? (
                  <div
                    className={css(styles.videoCursor)}
                    onClick={this.openModal}
                  >
                    {this.renderModal()}
                    <img src={playBtn} className={css(styles.playBtn)} /> Watch
                    video
                  </div>
                ) : (
                  ""
                )}
                {this.props.buttonText ? (
                  <SignUp
                    text={this.props.buttonText}
                    href={this.props.buttonLink}
                    target={this.props.buttonTarget}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <Media query="(max-width: 599px)">
              {matches =>
                matches ? (
                  <div
                    style={{
                      ...(config.development && !this.props.bgFill
                        ? {
                            backgroundImage: `url(${!this.props.bgFill &&
                              config.development &&
                              this.mobileImage()})`
                          }
                        : {}),
                      backgroundSize: this.props.bgCover ? "cover" : "contain",
                      display: "inherit"
                    }}
                  />
                ) : (
                  <div
                    style={{
                      ...(config.development && !this.props.bgFill
                        ? {
                            backgroundImage: `url(${!this.props.bgFill &&
                              config.development &&
                              this.props.bgImage})`
                          }
                        : {}),
                      backgroundSize: this.props.bgCover ? "cover" : "contain"
                    }}
                    className={`col-md-${colSize}  pt-5 ${css(
                      styles.imageStyle
                    )} bannerImage`}
                    {...(!this.props.bgFill && !config.development
                      ? { "data-src-bck": this.props.bgImage }
                      : {})}
                  />
                )
              }
            </Media>
            {this.props.logos ? (
              <div className="logoHolder">{this.showLogos(logos)}</div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default HeaderBanner;

const styles = StyleSheet.create({
  bannerStyle: {
    minHeight: "450px",
    color: "#fff",
    marginRight: "-25px!important",
    marginLeft: "-25px!important",
    "@media (max-width: 599px)": {
      minHeight: "300px",
      marginTop: "-30px"
    }
  },
  fontStyle: {
    fontWeight: "normal"
  },
  titleStyle: {
    fontWeight: 300,
    fontSize: "36px",
    textTransform: "uppercase",
    letterSpacing: "2px"
  },
  paragraph: {
    lineHeight: 1.8
  },
  imageStyle: {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    minHeight: "400px",
    backgroundSize: "contain"
  },
  imageStyleMobile: {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom!important",
    minHeight: "250px!important",
    backgroundSize: "contain",
    backgroundPositionY: "50px"
  },
  logo: {
    height: "50px",
    marginBottom: "20px"
  },
  playBtn: {
    height: "30px",
    marginRight: "10px"
  },
  videoCursor: {
    cursor: "pointer"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/headerBanner.js